<template>
  <div>
    <top-nav class="top-nav"></top-nav>
    <full-scroll :section-list="sectionList">
      <home-first class="section-block" slot="section0"></home-first>
      <home-second class="section-block" slot="section1"></home-second>
      <home-third class="section-block" slot="section2"></home-third>
      <home-four slot="section3"></home-four>
    </full-scroll>
  </div>
</template>

<script>
import FullScroll from '../../components/FullScroll';
import HomeFirst from './HomeFirst';
import HomeSecond from './HomeSecond';
import HomeThird from './HomeThird';
import HomeFour from './HomeFour';
import TopNav from '../../components/TopNav';

export default {
  name: 'Home',
  data() {
    return {
      sectionList: [
        {
          bg: require('../../assets/img/page_1.png'),
        },
        {
          bg: require('../../assets/img/page_2.png'),
        },
        {
          bg: require('../../assets/img/page_3.png'),
        },
        {
          bg: require('../../assets/img/page_4.png'),
        },
      ],
    };
  },
  computed: {
  },
  mounted() {
  },
  components: {
    TopNav,
    HomeFour,
    HomeThird,
    HomeSecond,
    HomeFirst,
    FullScroll,
  },
};
</script>

<style scoped lang="scss">
.top-nav{
  position: fixed;
  width: 100%;
  z-index: 3;
}
</style>
